import RestClient from './rest-client'

export default class Service extends RestClient {
  static get url () {
    return this.apiUrl + '/services'
  }

  static get paramKey () {
    return 'service'
  }

  static async exportServicePostals (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/export_service_postals`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
  }
  async addServiceZones (serviceZones) {
    const { data } = await this.constructor._post(this.constructor.url + '/service_zones', serviceZones)
    return data
  }

  async addServiceCountries (serviceCountries) {
    const { data } = await this.constructor._post(this.constructor.url + '/service_countries', serviceCountries)
    return data
  }

  static async toggleAdminVisibility (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/set_exportible_zip`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

}
